/**
 * Support command - Get help and support contact info
 * @module commands/support
 */

import * as clack from "@clack/prompts";
import pc from "picocolors";
import { trackCommand } from "../telemetry/events.js";

/**
 * Display support contact information and helpful links
 */
export async function support(): Promise<void> {
  trackCommand("support", { success: true });
  clack.intro(pc.bold("Get Help with Wraps"));

  console.log();
  console.log(`  ${pc.bold("Email:")}   ${pc.cyan("hey@wraps.dev")}`);
  console.log(
    `  ${pc.bold("GitHub:")}  ${pc.cyan("https://github.com/wraps-team/wraps/issues")}`
  );
  console.log(`  ${pc.bold("Docs:")}    ${pc.cyan("https://wraps.dev/docs")}`);
  console.log(
    `  ${pc.bold("AI docs:")} ${pc.cyan("https://wraps.dev/llms-full.txt")} ${pc.dim("(complete docs, one file)")}`
  );
  console.log();
  console.log(pc.dim("  Response time: Usually within 24 hours"));
  console.log();
}
